document.querySelectorAll('.sc-home-trullo__card').forEach((card) => {
  const preview = card.querySelector('.sc-home-trullo__card-alt-image');
  if (!preview || !preview.dataset.scPreviewSrc) return;

  const loadPreview = () => {
    if (preview.src) return;
    preview.addEventListener('load', () => card.setAttribute('data-sc-preview-ready', ''), { once: true });
    preview.srcset = preview.dataset.scPreviewSrcset;
    preview.src = preview.dataset.scPreviewSrc;
  };

  card.addEventListener('pointerenter', (event) => {
    if (event.pointerType === 'mouse') loadPreview();
  });
  card.addEventListener('focusin', loadPreview);
});
